import { changePasswordInput } from '@trafiku/contracts';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import { Field, Input } from '@/components/ui/form';
import { Card, PageHeader } from '@/components/ui/layout';
import { api } from '@/lib/api';
import { useAuth } from '@/lib/auth';
import { useFormState } from '@/lib/form';
import { t } from '@/lib/i18n';

export function AccountPage() {
  const { user, logout } = useAuth();
  const form = useFormState({ current_password: '', new_password: '' });
  return (
    <>
      <PageHeader
        title={t('My account')}
        subtitle={`${user?.email} · ${user?.role === 'admin' ? t('Administrator') : t('Operator')}`}
      />
      <Card title={t('Change password')} className="max-w-md">
        <form
          className="space-y-4"
          onSubmit={async (e) => {
            e.preventDefault();
            const ok = await form.submit(changePasswordInput, (d) =>
              api('/auth/password', { method: 'POST', body: d }),
            );
            if (ok) {
              toast.success(t('Password changed. Please sign in again.'));
              await logout();
            }
          }}
        >
          <Field label={t('Current password')} error={form.errors.current_password}>
            {(id) => (
              <Input
                id={id}
                type="password"
                autoComplete="current-password"
                value={form.values.current_password}
                onChange={(e) => form.set('current_password', e.target.value)}
              />
            )}
          </Field>
          <Field
            label={t('New password')}
            error={form.errors.new_password}
            hint={t('At least {n} characters', { n: 10 })}
          >
            {(id) => (
              <Input
                id={id}
                type="password"
                autoComplete="new-password"
                value={form.values.new_password}
                onChange={(e) => form.set('new_password', e.target.value)}
              />
            )}
          </Field>
          <Button type="submit">{t('Change password')}</Button>
        </form>
      </Card>
    </>
  );
}
